export default __webpack_public_path__ + "static/media/error.d512a0fa.png";